export const BID_OVERVIEW_TABS = ['compliance', 'bidOverview', 'awardCriteria'] as const;

export const BID_TYPES = ['PREQUALIFICATION', 'MAIN_TENDER'] as const;

export enum BidStatus {
  DEFAULT = 0,
  SUBMITTED = 20,
}
